import { PaymentMethod, PaymentMethods } from 'src/constants/PaymentMethod';
import type { CustomPaymentMethod } from 'src/types/Id';

export function isPaymentLinkPayment(paymentMethod?: PaymentMethod | CustomPaymentMethod | string): boolean {
    return paymentMethod === PaymentMethods.PAYMENT_LINK;
}
